<template>
  <div>
    <div :class="['app-font-size-input', inputContainerClass, { 'input-after': !!$slots.after }]">
      <div>{{ label }}</div>
      <AppSlider
        v-model="model"
        :min="min"
        :max="max"
      />
      <AppInput
        ref="input"
        v-model="model"
        v-bind="$attrs"
        bottom-slots
        @input="model = castValueAsNumber($event)"
      >
        <template #error/>
        <template #after>
          <slot name="after"/>
        </template>
      </AppInput>
    </div>
    <div
      v-if="errorMessage"
      class="text-13-400 text-negative q-mt-xs error"
    >
      <div/>
      <div>{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import castValueAsNumber from 'common/helpers/castNumberInput';
import AppInput from './AppInput';
import AppSlider from './AppSlider';

export default {
  name: 'AppSliderInput',
  components: {
    AppInput,
    AppSlider,
  },
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    label: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      default: 6,
    },
    max: {
      type: Number,
      default: 20,
    },
    inputContainerClass: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      model: undefined,
      errorMessage: undefined,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.model = this.value;
      },
    },
    async model() {
      this.$emit('input', this.model);
      if (Array.isArray(this.$attrs.rules) && this.$attrs.rules.length > 0) {
        await this.$nextTick();
        await this.$refs.input.validate();
        this.errorMessage = this.$refs.input.$refs.input.innerErrorMessage;
      }
    },
  },
  methods: {
    castValueAsNumber,
  },
};
</script>

<style scoped lang="scss">
.app-font-size-input {
  display: grid;
  align-items: center;
  gap: 20px;
  grid-template-columns: 100px 1fr 60px;

  &.input-after {
    grid-template-columns: 100px 1fr 100px;
  }

  .app-input {
    display: unset;
  }
}

.error {
  display: grid;
  align-items: center;
  gap: 20px;
  grid-template-columns: 100px 1fr;
}
</style>
